/** 
 * Import Ionic and others
 */
import { Component, Input } from '@angular/core';
import { App, Events, MenuController } from 'ionic-angular';

/**
 * Import Pages
 */
import { TutorialPage } from '../../pages/tutorial/tutorial';
import { HomePage } from '../../pages/home/home';
import { AccountPage } from '../../pages/account/account';
import { AccountLoginPage } from '../../pages/account-login/account-login';
import { AccountSignupPage } from '../../pages/account-signup/account-signup';

/**
 * Import Providers
 */
import { User } from '../../providers/user';

export interface PageInterface {
  title: string;
  component: any;
  icon: string;
  index?: number;
}
@Component({
  selector: 'app-menu',
  templateUrl: 'app-menu.html'
})
export class AppMenuComponent {
  @Input() content: any;
  profile: any = {};
  photo64: string;

  // List of pages that can be navigated to from the left menu
  // the left menu only tasks after login
  // the login page disables the left menu
  appPages: PageInterface[] = [
    //{ title: 'Tutorial', component: TutorialPage, icon: 'ios-book-outline' },
    { title: 'Gutscheine', component: HomePage, icon: 'ios-time-outline' }
  ];
  loggedInPages: PageInterface[] = [
    { title: 'Profil', component: AccountPage, icon: 'ios-person-outline' }
  ];
  loggedOutPages: PageInterface[] = [
    { title: 'Login', component: AccountLoginPage, icon: 'ios-log-in-outline' },
    { title: 'Registrieren', component: AccountSignupPage, icon: 'ios-person-add-outline' }
  ];
  constructor(
    public app: App,
    public user: User,
    public events: Events,
    public menu: MenuController) {

    // events
    this.eventsHandler();
  }

  openPage(page: PageInterface) {
    // the nav component was found using @ViewChild(Nav)
    // reset the nav to remove previous pages and only have this page
    // we wouldn't want the back button to show in this scenario
    if (page.index) {
      this.app.getActiveNav().setRoot(page.component, { tabIndex: page.index });
    } else {
      this.app.getActiveNav().setRoot(page.component);
    }
    if (page.title === 'Logout') {
      this.logout();
    }
  }

  openProfile() {
    this.app.getActiveNav().setRoot(AccountPage);
  }

  enableMenu(loggedIn) {
    this.menu.enable(loggedIn, 'loggedInMenu');
    this.menu.enable(!loggedIn, 'loggedOutMenu');
  }

  eventsHandler() {
    this.events.subscribe('user:loggedIn', () => {
      this.profile = this.user.profile();
      this.enableMenu(true);
    });
    this.events.subscribe('user:loggedOut', () => {
      this.enableMenu(false);
    });
    this.events.subscribe('user:photo64', (photo64) => {
      this.photo64 = photo64;
    });


  }

  logout() {
    this.user.logout();
  }
}



// WEBPACK FOOTER //
// ./src/components/app-menu/app-menu.ts